import { render } from "./BreakText.vue?vue&type=template&id=02061da2&scoped=true"
import script from "./BreakText.vue?vue&type=script&lang=js"
export * from "./BreakText.vue?vue&type=script&lang=js"

import "./BreakText.vue?vue&type=style&index=0&id=02061da2&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-02061da2"

export default script